import { useAtomValue } from 'jotai';
import { MutateOptions } from '@tanstack/query-core';
import { cloneQuoteAtom } from '../../../store/global/atoms';
import { ApiResponse } from '../../../ts';
import { CloneQuoteParams } from 'src/ts/interfaces/quotes/clone-quote-params';

type Options = MutateOptions<ApiResponse<any>, Error, CloneQuoteParams>;

export const useCloneQuote = () => {
  const cloneQuoteBase = useAtomValue(cloneQuoteAtom);
  
  const cloneQuote = {
    transfer: (cloneQuoteParams: CloneQuoteParams, options?: Options) =>
      cloneQuoteBase.mutate(cloneQuoteParams, options),

    receipt: (cloneQuoteParams: CloneQuoteParams, options?: Options) =>
      cloneQuoteBase.mutate(cloneQuoteParams, options),

    card: (cloneQuoteParams: CloneQuoteParams, options?: Options) =>
      cloneQuoteBase.mutate(cloneQuoteParams, options),
  };

  return {
    cloneQuoteResult: cloneQuoteBase.data,
    cloneQuote,
    error: cloneQuoteBase.error,
    isLoading: cloneQuoteBase.isPending,
  };
};
